import {
  Component,
  Input,
  ElementRef,
  SimpleChanges,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SetComponentsService } from '../../../services/edit/set-components.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from '../../../services/config/config.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../../side-nav/sidenav-content';

@Component({
  selector: 'edit-c-cta',
  templateUrl: './edit-c-cta.component.html',
  styleUrls: ['./edit-c-cta.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EditCCtaComponent extends SidenavContent implements OnChanges {
  @Input() cta: any;
  @Input() template: any;
  @Input() rowType: any;
  @Input() rowArray: any;
  @Input() compArray: any;
  @Input() edit: boolean;
  @Input() defaultColors: any = true;
  @Input() starterTheme = '';

  imgTitle: string;
  isCollapsed = true;
  title: string;
  background = '';
  color = 'white';
  flushed: boolean;
  titleBack = '';
  paragraph: string;
  paraBack: string;
  fileUploadCheck = false;
  selectedFile: File | null = null;
  isUploading = false;
  targetUrl = '';
  imgUrl = '';
  backOpacity: string;
  backPos = 'center';
  backSize = '';
  btnShow = false;
  btnLabel: string;
  btnClass = 'btn btn-primary';

  private _temp: any;
  private _OneColumn: boolean;
  private _TwoColumns: boolean;
  private _ThreeColumns: boolean;
  private _FourColumns: boolean;
  private _FiveColumns: boolean;
  private _SixColumns: boolean;

  // Form Variables
  private _typeOf: any = 'cta';
  private _rowClass = '';
  private _icon: string;
  private _iconSize: string;
  private _newTab: boolean;
  // for getCTAstyles()
  private _filter: string;
  private _backRepeat = 'no-repeat';
  private _backAttach: string;
  // Button changes.
  // did not make the first cut.
  private _paraBorder: any;
  private _titleBorder: any;
  private _backFilter: any;
  private _uri: string = this._configService.expressApi + '/file/upload';

  constructor(
    private _el: ElementRef,
    private _http: HttpClient,
    private _snackBar: MatSnackBar,
    private _configService: ConfigService,
    private _layoutService: LayoutService,
    private _editService: SetComponentsService,
  ) {
    super(_layoutService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.template) {
      this._temp = changes.template.currentValue;
      this.template = this._temp;
    }
    if (changes.rowType) {
      this.rowType = changes.rowType.currentValue;
    }
    if (changes.rowArray) {
      this.rowArray = changes.rowArray.currentValue;
    }
    if (changes.compArray) {
      this.compArray = changes.compArray.currentValue;
    }
    if (changes.edit) {
      this.edit = changes.edit.currentValue;
    }

    if (this.edit) {
      this.setRowType();
      this.getFormVariables();
      this.fileUploadCheck = true;
    } else {
      this.setNewVariables();
    }

    if (changes.starterTheme) {
      this.starterTheme = changes.starterTheme.currentValue;
    }
    //
    // if edit is false, set the more options colors for the component to the default templates foregorund and back ground color if a new component is loaded.
    //  fi edit is true, laod the more options color from the template value above which is retrived from mongo
    if (!this.edit && this.template && this.starterTheme !== '' && this.starterTheme) {
      if (changes.defaultColors) {
        this.defaultColors = changes.defaultColors.currentValue;
        if (this.defaultColors) {
          this.color = this.defaultColors.fontColor;
          this.background = this.defaultColors.backColor;
        }
      }
    }
  }

  setNewVariableValues() {
    this.backPos = 'center';
    this.backSize = 'cover';
    this.title = '';
    this.imgTitle = '';
    this.background = '';
    this.color = '';
    this.flushed = true;
    this.titleBack = '';
    this.paragraph = '';
    this.paraBack = '';
    this._icon = '';
    this._iconSize = '';
    this.targetUrl = '';
    this._newTab = true;
    this.imgUrl = '';
    this.backOpacity = '';
    this._filter = '';
    this._backRepeat = 'no-repeat';
    this._backAttach = 'scroll';
    this.btnShow = false;
    this.btnLabel = '';
    this.btnClass = 'btn btn-primary';
  }

  setNewVariables() {
    this.setNewVariableValues();
    switch (this.rowType) {
      case 'col-2':
        this._rowClass = 'two-links height-250';
        break;
      case 'col-21':
        this._rowClass = 'two-links height-250';
        break;
      case 'col-2-1-2':
        this._rowClass = 'two-links height-250';
        break;
      case 'col-2-1-3':
        this._rowClass = 'two-links height-250';
        break;
      case 'col-2-2-1':
        this._rowClass = 'two-links height-250';
        break;
      case 'col-2-3-1':
        this._rowClass = 'two-links height-250';
        break;
      case 'col-31':
        this._rowClass = 'three-links height-200';
        break;
      case 'col-3-1-1-2':
        this._rowClass = 'three-links height-200';
        break;
      case 'col-3-1-2-1':
        this._rowClass = 'three-links height-200';
        break;
      case 'col-3-2-1-1':
        this._rowClass = 'three-links height-200';
        break;
      case 'col-42':
        this._rowClass = 'four-links height-200';
        break;
      case 'col-421':
        this._rowClass = 'four-links height-200';
        break;
      case 'col-51':
        this._rowClass = 'height-200';
        break;
      case 'col-632':
        this._rowClass = 'height-250';
        break;
      default:
        this._rowClass = 'one-link height-350';
    }
  }

  getFormVariables() {
    // Form Variables
    this._typeOf = 'cta'; // we force now to cta
    this.title = this._temp[this.compArray].title;
    this.imgTitle = this._temp[this.compArray].imgTitle
      ? this._temp[this.compArray].imgTitle
      : this.imgTitle;
    this.background = this._temp[this.compArray].background;
    this.color = this._temp[this.compArray].color;
    this.flushed = this._temp[this.compArray].flushed;
    this._rowClass = this._temp[this.compArray].rowClass
      ? this._temp[this.compArray].rowClass
      : this._rowClass;
    this.titleBack = this._temp[this.compArray].titleBack;
    this.paragraph = this._temp[this.compArray].paragraph;
    this.paraBack = this._temp[this.compArray].paraBack;
    this._icon = this._temp[this.compArray].icon;
    this._iconSize = this._temp[this.compArray].iconSize;
    this.targetUrl = this._temp[this.compArray].targetUrl;
    this._newTab = this._temp[this.compArray].newtab;
    // for gettempstyles()
    this.imgUrl = this._temp[this.compArray].imgUrl;
    this.backOpacity = this._temp[this.compArray].backOpacity;
    this._filter = this._temp[this.compArray].filter;
    this._backRepeat = this._temp[this.compArray].backRepeat;
    this._backAttach = this._temp[this.compArray].backAttach;
    this.backPos = this._temp[this.compArray].backPos;
    this.backSize = this._temp[this.compArray].backSize;
    // Button changes.
    this.btnShow = this._temp[this.compArray].btnShow;
    this.btnLabel = this._temp[this.compArray].btnLabel;
    this.btnClass = this._temp[this.compArray].btnClass;
  }

  setRowType() {
    // Just in case values are null, pre-populate.
    switch (this.rowType) {
      case 'col-2':
      case 'col-21':
      case 'col-2-1-2':
      case 'col-2-1-3':
      case 'col-2-2-1':
      case 'col-2-3-1':
        this._TwoColumns = true;
        this._rowClass = 'two-links height-250';
        break;
      case 'col-31':
      case 'col-3-1-1-2':
      case 'col-3-1-2-1':
      case 'col-3-2-1-1':
        this._ThreeColumns = true;
        this._rowClass = 'three-links height-200';
        break;
      case 'col-42':
      case 'col-421':
        this._FourColumns = true;
        this._rowClass = 'four-links height-200';
        break;
      case 'col-51':
        this._FiveColumns = true;
        this._rowClass = 'height-200';
        break;
      case 'col-632':
        this._SixColumns = true;
        this._rowClass = 'height-250';
        break;
      default:
        this._OneColumn = true;
        this._rowClass = 'one-link height-350';
    }
  }

  getCTAstyles() {
    const result = {
      color: this.color,
      'background-color': this.background,
      'background-image': 'url(' + this.imgUrl + ')',
      opacity: this.backOpacity,
      filter: 'alpha(opacity=' + this._filter + ')',
      'background-repeat': this._backRepeat,
      'background-attachment': this._backAttach,
      'background-position': this.backPos,
      'background-size': this.backSize,
    };
    return result;
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      if (file.size > 5_000_000) {
        this.openSnackBar('Image size too large — exceeded 5MB', 'ok');
        input.value = '';
        this.selectedFile = null;
        return;
      }
      this.selectedFile = file;
    }
  }

  uploadImage() {
    if (!this.selectedFile) {
      return;
    }
    this.isUploading = true;
    const formData = new FormData();
    formData.append('photo', this.selectedFile, this.selectedFile.name);
    const params = new HttpParams();
    this._http.post(this._uri, formData, { params }).subscribe({
      next: (response: any) => {
        this.openSnackBar('Image uploaded', 'ok');
        this.fileUploadCheck = true;
        this.imgUrl = '/uploads/' + response.uploadname;
        this.selectedFile = null;
        this.isUploading = false;
      },
      error: (err: unknown) => {
        console.error('Upload image error', err);
        this.openSnackBar('Upload failed', 'ok');
        this.isUploading = false;
      },
    });
  }

  updateCTA(cta) {
    if (this.imgUrl && /\S/.test(this.imgUrl)) {
      const result = {
        typeOf: 'cta',
        rowClass: this._rowClass,
        flushed: this.flushed,
        color: this.color,
        title: this.title,
        imgTitle: this.imgTitle,
        titleBack: this.titleBack,
        titleBorder: this._titleBorder,
        paragraph: this.paragraph,
        paraBack: this.paraBack,
        paraBorder: this._paraBorder,
        icon: this._icon,
        iconSize: this._iconSize,
        newtab: this._newTab,
        // 'targetUrl' : 'https://' + this.targetUrl,
        targetUrl: this.targetUrl ? this.targetUrl : '',
        background: this.background,
        imgUrl: this.imgUrl,
        backOpacity: this.backOpacity,
        backFilter: this._backFilter,
        backRepeat: this._backRepeat,
        backAttach: this._backAttach,
        backPos: this.backPos,
        backSize: this.backSize,
        btnShow: this.btnShow,
        // 'btnLabel' : this.btnLabel != '' ? this.btnLabel : 'button',
        btnLabel: this.btnLabel,
        btnClass: this.btnClass,
      };
      if (this.btnShow) {
        if (
          /\S/.test(this.btnLabel) &&
          this.btnLabel &&
          this.btnLabel != null &&
          this.btnLabel != ''
        ) {
          this._editService.setCTA(result, this.rowType, this._temp, this.rowArray, this.compArray);
        } else {
          const message = 'enter the button label';
          this.openSnackBar(message, 'ok');
        }
      } else {
        this._editService.setCTA(result, this.rowType, this._temp, this.rowArray, this.compArray);
      }
    } else {
      const message = 'please upload an image first';
      this.openSnackBar(message, 'ok');
    }
  }

  submitCTA(cta) {
    if (this.imgUrl && /\S/.test(this.imgUrl)) {
      const result = {
        typeOf: 'cta',
        rowClass: this._rowClass,
        flushed: this.flushed,
        color: this.color,
        title: this.title,
        imgTitle: this.imgTitle,
        titleBack: this.titleBack,
        titleBorder: this._titleBorder,
        paragraph: this.paragraph,
        paraBack: this.paraBack,
        paraBorder: this._paraBorder,
        icon: this._icon,
        iconSize: this._iconSize,
        newtab: this._newTab,
        // 'targetUrl' : this.targetUrl ? this.targetUrl : '',
        targetUrl: this.targetUrl ? this.targetUrl : '',
        background: this.background,
        imgUrl: this.imgUrl,
        backOpacity: this.backOpacity,
        backFilter: this._backFilter,
        backRepeat: this._backRepeat,
        backAttach: this._backAttach,
        backPos: this.backPos,
        backSize: this.backSize,
        btnShow: this.btnShow,
        btnLabel: this.btnLabel,
        // 'btnLabel': this.btnLabel != '' ? this.btnLabel : 'button',
        btnClass: this.btnClass,
      };

      if (this.btnShow) {
        if (
          /\S/.test(this.btnLabel) &&
          this.btnLabel &&
          this.btnLabel != null &&
          this.btnLabel != ''
        ) {
          this._editService.setCTA(result, this.rowType, this._temp, this.rowArray, this.compArray);
          this.closeNav();
        } else {
          const message = 'enter the button label';
          this.openSnackBar(message, 'ok');
        }
      } else {
        this._editService.setCTA(result, this.rowType, this._temp, this.rowArray, this.compArray);
        this.closeNav();
      }
    }
  }

  //-----------------------------------------------------------------------------------------------
  //---------------------------------- user experience --------------------------------------------
  //-----------------------------------------------------------------------------------------------
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }

  setNewTab(event) {
    this._newTab = event.checked;
  }

  setButton(event) {
    this.btnShow = event.checked;
  }
}
